import { useAppSelector } from 'hooks/reduxHooks'
import { CHARTER_OFFERS_VISIBLE_GEO_STATES } from 'constants/config/region'

export function useHideCharterOffersFromSearch(): boolean {
  const geoStateName = useAppSelector((state) => state.geo.geoStateName)
  const regionCode = useAppSelector((state) => state.geo.currentRegionCode)

  if (regionCode !== 'AU') return true
  if (!geoStateName) return false

  const normalized = geoStateName.toLowerCase()
  return !CHARTER_OFFERS_VISIBLE_GEO_STATES.some((state) => state.toLowerCase() === normalized)
}
